import { Button } from '@mui/material'
const DownloadButton = ({ id, title, onClick }) => {
  return (
    <Button className={`w-auto button-tr${id === 1 ? '-2' : '-citizen-cancel'}`} onClick={onClick}>
      {title}
    </Button>
  )
}
export default DownloadButton
